/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Companies_HeadingInputs */

const en_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const de_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const fr_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const es_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const it_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const nl_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const pl_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const fi_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const da_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

const sv_portal_scanner_companies_heading = /** @type {(inputs: Portal_Scanner_Companies_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companies`)
};

/**
* | output |
* | --- |
* | "Companies" |
*
* @param {Portal_Scanner_Companies_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_companies_heading = /** @type {((inputs?: Portal_Scanner_Companies_HeadingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Companies_HeadingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_companies_heading(inputs)
	if (locale === "fr") return fr_portal_scanner_companies_heading(inputs)
	if (locale === "es") return es_portal_scanner_companies_heading(inputs)
	if (locale === "it") return it_portal_scanner_companies_heading(inputs)
	if (locale === "nl") return nl_portal_scanner_companies_heading(inputs)
	if (locale === "pl") return pl_portal_scanner_companies_heading(inputs)
	if (locale === "fi") return fi_portal_scanner_companies_heading(inputs)
	if (locale === "da") return da_portal_scanner_companies_heading(inputs)
	if (locale === "sv") return sv_portal_scanner_companies_heading(inputs)
	return en_portal_scanner_companies_heading(inputs)
});